import { KeyboardEventHandler, useEffect, useRef } from 'react';

interface Props {
  onKeyDown: KeyboardEventHandler<HTMLDivElement>;
}

export const KeyDownAutoFocus = ({ onKeyDown }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, [ref]);

  return <div tabIndex={0} ref={ref} onKeyDown={onKeyDown}></div>;
};
